export default __webpack_public_path__ + "static/media/affiliate-woman-2.954e9121.svg";